export default {
  wishlist: {
    sidebar: {
      headerTitle: 'Your wishlist',
      items: 'Items',
    },
    productCard: {
      removeFromWishlistLabel: 'Remove',
      addToWishlistLabel: 'Save',
    },
  },
}
